import React, { useEffect, useState } from 'react';
import * as ReactDOM from 'react-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
} from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  IN_REQUEST_INF_TYPE_ENUM, USER_TYPE,
} from '../../../configs';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import Loader from '../../../components/base/Loader/Loader';
import { getApplicationData } from '../../Application/reducer';
import CarrierForm from './FormBlocks/CarrierForm';
import WayBillForm from './FormBlocks/WayBillForm';
import DriverForm from './FormBlocks/DriverForm';
import CarriageContractForm from './FormBlocks/CarriageContractForm';
import MedicalExamForm from './FormBlocks/MedicalExamForm';
import TariffForm from './FormBlocks/TariffForm';
import TripForm from './FormBlocks/TripForm';
import LocationForm from './FormBlocks/LocationForm';
import OsgopForm from './FormBlocks/OsgopForm';
import OsagoForm from './FormBlocks/OsagoForm';
import VehicleFrom from './FormBlocks/VehicleFrom';
import { createInformation } from '../actions';
import { localeFormatter } from '../../../utils/formatters';
import FormHeader from './FormHeader';
import { getResponseError, setFormError } from '../../../utils/utils';
import { transformStructureToErrors } from '../../../utils/transformStructureToErrors';

export default function InformationForm(props) {
  const {
    onCancel = () => {},
    onClose = () => {},
    loadData = () => {},
    selectedProcedure = null,
  } = props;
  const { loadingCreateApplication, loadingEditApplicationById } = useSelector(getApplicationData);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState();
  const [carrierType, setCarrierType] = useState();
  const [defs] = useState({
    carrier_type: USER_TYPE.PRIVATE_PERSON,
  });

  const {
    watch, control, getValues, formState: { errors }, setError,
  } = useForm({
    mode: 'onChange',
    defaultValues: defs,
  });

  React.useEffect(() => {
    const subscription = watch(values => {
      if (values && typeof values.carrier_type !== 'undefined') {
        setCarrierType(values.carrier_type);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const handleSave = () => {
    const values = getValues();
    dispatch(createInformation({ values, procedure: selectedProcedure })).then(() => {
      successNotification('Сохранение формы сведений', 'Форма сохранена');
      loadData();
      onClose();
    }).catch(response => {
      errorNotification('Сохранение формы сведений', getResponseError({ error: response && response.message ? response.message : '' }));
      setFormError({ errors: transformStructureToErrors(response?.errors) }, setError);
    });
  };

  if (!selectedProcedure) return null;

  return ReactDOM.createPortal(
    <div className="information-form">
      <Loader loading={loader || loadingCreateApplication || loadingEditApplicationById} />
      <FormHeader onClose={onClose} procedure={selectedProcedure} title="Подача сведений о транспортном средстве" />
      <div className="information-form-body">
        <form className="information-form-content">
          <div className="information-form-fields-header">Заполните информацию о {localeFormatter('in_request_inf.type', selectedProcedure)}</div>
          <div className="information-form-fields">
            <div className="information-form-fields-wrapper custom-scroll-theme">
              <div className="afc-body">
                <div className="afc-main">
                  <form>
                    <div className="f4">Общая информация</div>
                    { selectedProcedure === IN_REQUEST_INF_TYPE_ENUM.VEHICLE ? <VehicleFrom control={control} /> : null }
                    { selectedProcedure === IN_REQUEST_INF_TYPE_ENUM.OSAGO ? <OsagoForm control={control} /> : null }
                    { selectedProcedure === IN_REQUEST_INF_TYPE_ENUM.OSGOP ? <OsgopForm control={control} /> : null }
                    { selectedProcedure === IN_REQUEST_INF_TYPE_ENUM.LOCATION ? <LocationForm control={control} /> : null }
                    { selectedProcedure === IN_REQUEST_INF_TYPE_ENUM.TRIP ? <TripForm legalEntityType={carrierType} control={control} /> : null }
                    { selectedProcedure === IN_REQUEST_INF_TYPE_ENUM.TARIFF ? <TariffForm control={control} /> : null }
                    { selectedProcedure === IN_REQUEST_INF_TYPE_ENUM.MEDICAL_EXAM ? <MedicalExamForm control={control} /> : null }
                    { selectedProcedure === IN_REQUEST_INF_TYPE_ENUM.CARRIAGE_CONTRACT ? <CarriageContractForm control={control} /> : null }
                    { selectedProcedure === IN_REQUEST_INF_TYPE_ENUM.DRIVER ? <DriverForm legalEntityType={carrierType} control={control} /> : null }
                    { selectedProcedure === IN_REQUEST_INF_TYPE_ENUM.WAYBILL ? <WayBillForm legalEntityType={carrierType} control={control} /> : null }
                    { selectedProcedure === IN_REQUEST_INF_TYPE_ENUM.CARRIER ? <CarrierForm legalEntityType={carrierType} control={control} /> : null }
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="information-form-footer">
            <Button onClick={() => handleSave()}>Сохранить</Button>
            <Button variant="secondary" onClick={onCancel}>Отменить</Button>
          </div>
        </form>
      </div>
    </div>,
    document.getElementById('app-content'),
  );
}
